import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { withStyles, useTheme } from '@material-ui/core/styles';
import { fontSize, colors } from '../../constants/styleConstants';

const tooltipBaseStyles = {
  backgroundColor: colors.white,
  color: colors.textColor,
  borderRadius: '4px',
  boxShadow:
    '0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 24px 38px 3px rgba(0, 0, 0, 0.14)',
  maxWidth: '237px',
  fontSize: fontSize.basic,
};
const CustomTooltip = ({ icon, content, styles }) => {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.up('sm'));

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  const HtmlTooltip = withStyles(() => ({
    tooltip: styles || tooltipBaseStyles,
  }))(Tooltip);
  return !mobile ? (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <HtmlTooltip
        arrow
        title={content}
        onClose={handleTooltipClose}
        open={open}
        disableFocusListener
        disableHoverListener={false}
        disableTouchListener
        onClick={handleTooltipOpen}
      >
        {icon}
      </HtmlTooltip>
    </ClickAwayListener>
  ) : (
    <HtmlTooltip arrow title={content}>
      {icon}
    </HtmlTooltip>
  );
};

CustomTooltip.propTypes = {
  icon: PropTypes.object,
  content: PropTypes.object,
  styles: PropTypes.object,
};

export default CustomTooltip;
